import React from "react";
import {
  Dimensions,
  Pressable,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";

import NoBag from "@assets/svg/NoBag";
import PolyBagIcon from "@assets/svg/MyTasks/PolyBagIcon";
import Cash from "@assets/svg/RRD/Cash";
import Text from "@components/CustomText";
import Tag from "@components/Tag";
import colors from "@constants/color";
import t from "@constants/localization";
import ArrowDown from "@assets/svg/ArrowDown";
import LinearGradient from "react-native-linear-gradient";
import Button from "./Button";
import ContactAndActionBtns from "./ContactAndActionBtns";
import DelayTag from "./DelayTag";
import DeliveredFooter from "./DeliveredFooter";
import RtoFooter from "./RtoFooter";
import RescheduleFooter from "./RescheduleFooter";
import TimeSlotTag from "./TimeSlotTag";
import { tripCardLabel } from "@screens/CpDeliveryRoutes/cardHelpers";

// Indigo trip chip -- same colours the boy app (partner-db MyTasks) and the
// leader OFD card use, so one trip reads identically across all three screens.
const TRIP_TAG_BG = "#EEF2FF";
const TRIP_TAG_FG = "#4338CA";

function DeliveryCard({
  item,
  onPressCall,
  openMaps,
  onPressBtn,
  handlePressItemspopup,
  handlePressEditCallOptions,
  taskActionConfig,
  contactOpts = [],
}) {
  const PATH = "screens/MyTask";
  return (
    <View style={[styles.listView, (item?.is_escalated || item?.is_priority_cx) && styles.highlightedCard]}>
      <LinearGradient
        colors={["#F8F8F8", "#EAEAEA"]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        style={styles.topCardHeader}
      >
        {/*
          The trip chip gets a row of its own, ABOVE the header row, mirroring
          the boy app (partner-db MyTasks DeliveryCard). Inline beside
          route_name it added its full width to a column already capped at 70%
          that the delay/priority/escalated badges also share -- on a narrow
          screen the long `Trip · …<last6>` label got clipped. On its own row it
          costs the header row nothing, so that row lays out exactly as before.

          A card with no trip renders NO row (tripCardLabel returns null), so the
          band keeps its single child and is pixel-identical to today.
        */}
        {tripCardLabel(item) ? (
          <View style={styles.tripRow}>
            <Tag
              text={tripCardLabel(item)}
              bgcolor={TRIP_TAG_BG}
              textColor={TRIP_TAG_FG}
              borderColor={TRIP_TAG_FG}
            />
          </View>
        ) : null}
        <View style={styles.topCardHeaderRow}>
        <View style={{ maxWidth: "70%" }}>
          <Text
            variant="body_text_3"
            style={{ color: colors.mediumBlacklightBlack }}
          >
            {item?.route_name}
          </Text>
          {item?.show_items_list_popup ? (
            <Pressable
              onPress={() => handlePressItemspopup(item)}
              testID="mt-bm-btn"
            >
              <View style={styles.bagmodalContainer}>
                <Text variant="subtitle_16" style={{ marginRight: 6 }}>
                  {t(`${PATH}/click_to_view_list`)}
                </Text>
                <ArrowDown />
              </View>
            </Pressable>
          ) : (
            <View style={styles.bagsContainer}>
              {Array.isArray(item?.bags) &&
              item?.bags?.length > 0 &&
              item?.state === "PACKED" &&
              item?.bags.every((bag) => bag !== "") ? (
                item?.bags?.map((i, index) => (
                  <Text
                    key={`${i}-${index}`}
                    variant="heading_24"
                    style={{ fontSize: 22, lineHeight: 28 }}
                  >
                    {index === item?.bags?.length - 1 ? i : `${i}, `}
                  </Text>
                ))
              ) : item?.show_no_bag_icon === true ? (
                <View style={{ paddingBottom: 4 }}>
                  <NoBag />
                </View>
              ) : null}
            </View>
          )}
          {item?.plastic_bag_opted_in && !item?.show_items_list_popup ? (
            <Pressable
              onPress={() => handlePressItemspopup(item)}
              testID="mt-bm-btn-plastic"
            >
              <View style={styles.bagmodalContainer}>
                <Text variant="subtitle_16" style={{ marginRight: 6 }}>
                  {t(`${PATH}/click_to_view_list`)}
                </Text>
                <ArrowDown />
              </View>
            </Pressable>
          ) : null}
        </View>
        <View style={{ paddingBottom: 8 }}>
          {item?.delay && (
            <View>
              <DelayTag delay={item?.delay} />
            </View>
          )}
          {item?.is_priority_cx && (
            <View style={{ marginTop: 6 }}>
              <Tag text="Priority" />
            </View>
          )}
          {item?.is_escalated && (
            <View style={{ marginTop: 6 }}>
              <Tag text="Escalated" />
            </View>
          )}
          {item?.preferred_slots ? (
            <View style={{ marginTop: 6 }}>
              <TimeSlotTag timeSlot={item?.preferred_slots} />
            </View>
          ) : null}
        </View>
        </View>
      </LinearGradient>
      <View style={styles.cardHeaderContainer}>
        <View style={styles.view1}>
          <View style={styles.nameContainer}>
            <Text variant="body_text_2" style={styles.name}>
              {item?.user_name}
            </Text>
            <Text variant="caption_2" style={styles.distance}>
              {item?.distance}
            </Text>
          </View>
        </View>
        <TouchableOpacity
          testID="mt-open-map"
          onPress={() => openMaps(item?.cx_lat, item?.cx_lng)}
        >
          <Text variant="body_text_3" style={styles.address}>
            {item?.cx_formatted_address}
          </Text>
        </TouchableOpacity>
        {item?.phone_number_1 || item?.phone_number_2 ? (
          <View
            style={{
              flexDirection: "row",
              alignItems: "flex-end",
              justifyContent: "space-between",
            }}
          >
            <ContactAndActionBtns
              item={item}
              onPressCall={onPressCall}
              handlePressEditCallOptions={handlePressEditCallOptions}
              taskActionConfig={taskActionConfig}
              contactOpts={contactOpts}
            />
            {item?.plastic_bag_opted_in && (
              <View style={{ marginBottom: 8 }}>
                <Tag
                  text="पॉली बैग"
                  bgcolor="#FFF9E6"
                  textColor="#B45309"
                  borderColor="#B45309"
                  icon={<PolyBagIcon color="#B45309" width={14} height={14} />}
                />
              </View>
            )}
          </View>
        ) : item?.plastic_bag_opted_in ? (
          <View style={{ marginTop: 12, alignItems: "flex-end" }}>
            <Tag
              text="पॉली बैग"
              bgcolor="#FFF9E6"
              textColor="#B45309"
              borderColor="#B45309"
              icon={<PolyBagIcon color="#B45309" width={14} height={14} />}
            />
          </View>
        ) : null}
      </View>
      {item?.all_prepaid_orders ? (
        <View
          style={[
            styles.amountOverviewContainer,
            {
              justifyContent: "space-between",
              marginBottom: item?.buttonsInfo?.length > 0 ? 0 : 8,
            },
          ]}
        >
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Cash pay={true} />
            <Text
              variant="body_text_1"
              style={{
                paddingHorizontal: 8,
                lineHeight: 26,
                color: colors.mediumBlacklightBlack,
              }}
            >
              {t(`${PATH}/prepaid_order`)}
            </Text>
          </View>
          <Text
            variant="body_text_1"
            style={{
              paddingHorizontal: 8,
              lineHeight: 26,
              color: colors.mediumBlacklightBlack,
            }}
          >
            {t(`${PATH}/pending_payment`)}
            <Text
              variant="body_text_2"
              style={{
                color: colors.black,
                lineHeight: 26,
              }}
            >
              {item?.amount_to_collect_txt}
            </Text>
          </Text>
        </View>
      ) : Math.abs(item?.amount_to_collect) > 0 ? (
        <View
          style={[
            styles.amountOverviewContainer,
            { marginBottom: item?.buttonsInfo?.length > 0 ? 0 : 8 },
          ]}
        >
          <Cash pay={true} />
          <Text
            variant="body_text_1"
            style={{
              paddingHorizontal: 8,
              lineHeight: 26,
              color: colors.mediumBlacklightBlack,
            }}
          >
            {t(`${PATH}/pay_by_cx`)}
            <Text
              variant="body_text_2"
              style={{
                color: colors.black,
                lineHeight: 26,
              }}
            >
              {item?.amount_to_collect_txt}
            </Text>
          </Text>
        </View>
      ) : Math.abs(item?.amount_collected) > 0 ? (
        <View
          style={[
            styles.amountOverviewContainer,
            {
              paddingHorizontal: 8,
              marginBottom: item?.buttonsInfo?.length > 0 ? 0 : 8,
            },
          ]}
        >
          <Text
            variant="body_text_1"
            style={{
              paddingHorizontal: 8,
              lineHeight: 26,
              color: colors.mediumBlacklightBlack,
            }}
          >
            {t(`${PATH}/amount_collected`)}
            <Text
              variant="body_text_2"
              style={{
                color: colors.black,
                lineHeight: 26,
              }}
            >
              {item?.amount_collected_txt}
            </Text>
          </Text>
        </View>
      ) : null}

      {item?.card_type === "RTO_CAN_CANCEL" && item?.footer && (
        <RtoFooter footer={item?.footer} />
      )}
      {item?.card_type === "DELIVERED" && item?.footer && (
        <>
          <View style={styles.divider} />
          <DeliveredFooter footer={item?.footer} />
        </>
      )}
      {item?.card_status === "RESCHEDULED" && item?.footer && (
        <>
          <View style={styles.divider} />
          <RescheduleFooter footer={item?.footer} />
        </>
      )}
      {item?.buttonsInfo?.length > 0 && (
        <View style={styles.bottomButtonContainer}>
          <View style={styles.buttonContainer}>
            {item?.buttonsInfo?.map((button) => (
              <Button
                key={button?.key}
                title={button?.value}
                type={button?.type}
                backgroundColor={
                  button?.color === "primary"
                    ? "rgba(25, 129, 85, 1)"
                    : "rgba(0, 0, 0, 0.05)"
                }
                btnColor={
                  button?.color === "primary"
                    ? "rgba(25, 129, 85, 1)"
                    : "rgba(0, 0, 0, 0.2)"
                }
                textColor={
                  button?.color === "primary"
                    ? colors.white
                    : colors.mediumBlack
                }
                onPress={() => {
                  onPressBtn(button?.key, item);
                }}
                icon={button?.icon || null}
                disabled={button.color === "disabled"}
              >
                {item?.button_amount_txt ? (
                  <View style={styles.amountContainer}>
                    <Text
                      variant="caption_3"
                      style={{ color: colors.btnGreen, fontWeight: "700" }}
                    >
                      {item?.button_amount_txt}
                    </Text>
                  </View>
                ) : null}
                {item?.delivered_button_amount_txt ? (
                  <View style={styles.amountContainer}>
                    <Text
                      variant="caption_3"
                      style={{ color: colors.btnGreen, fontWeight: "700" }}
                    >
                      {item?.delivered_button_amount_txt}
                    </Text>
                  </View>
                ) : null}
              </Button>
            ))}
          </View>
        </View>
      )}
    </View>
  );
}

export default DeliveryCard;

const styles = StyleSheet.create({
  bottomButtonContainer: {
    marginBottom: 16,
    paddingHorizontal: 10,
  },
  buttonContainer: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  listView: {
    backgroundColor: colors.white,
    borderRadius: 10,
    elevation: 2,
    overflow: "hidden",
    marginHorizontal: 16,
    marginVertical: 8,
  },
  highlightedCard: {
    borderWidth: 1,
    borderColor: "rgba(66, 116, 234, 1)",
  },
  view1: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  divider: {
    height: 1,
    backgroundColor: colors.lighterBlack,
  },

  name: {
    paddingHorizontal: 2,
    maxWidth: Dimensions.get("window").width * 0.65,
  },

  distance: {
    color: colors.mediumBlacklightBlack,
    marginLeft: 4,
    fontWeight: "500",
    lineHeight: 18,
  },
  address: {
    // maxWidth: "80%",
    color: "#4274EA",
    textDecorationLine: "underline",
  },
  cardHeaderContainer: {
    padding: 16,
    paddingVertical: 16,
    paddingTop: 12,
  },
  nameContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  amountOverviewContainer: {
    flexDirection: "row",
    paddingHorizontal: 16,
    alignItems: "center",
  },
  topCardHeader: {
    // A column now: an optional trip row, then the header row that used to BE
    // this element. With no trip chip there is one child and the band renders
    // exactly as the row did before the trip feature.
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    padding: 16,
    paddingVertical: 8,
    paddingBottom: 2,
    marginHorizontal: 1,
    marginTop: 1,
  },
  topCardHeaderRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
  },
  tripRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 4,
  },
  bagsContainer: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
  },
  bagmodalContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: colors.white,
    elevation: 1,
    marginVertical: 4,
    borderRadius: 14,
    justifyContent: "center",
    paddingVertical: 2,
    paddingHorizontal: 6,
  },
  amountContainer: {
    backgroundColor: "rgba(236, 252, 229, 1)",
    borderRadius: 9,
    justifyContent: "center",
    paddingBottom: 2,
    paddingTop: 1,
    paddingHorizontal: 6,
    marginLeft: 4,
    bottom: 1,
  },
});
